import { useState, useEffect } from "react";
import { updateAddress } from "../../api/auth";
import { getUserDetails } from "../../api/auth";

const ProfileComponent = ({user}) => {
    const [currentAddress, setCurrentAddress] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [postcode, setPostcode] = useState("");
    const [state, setState] = useState("");


    useEffect(() => {
        async function fetchUserData() {
            const userDetails = await getUserDetails();
            if (userDetails) {
                setCurrentAddress(`${userDetails.address} ${userDetails.city} ${userDetails.postcode} ${userDetails.state}`); // Corrected string formatting
            }
        }
        fetchUserData();
    }, []); // Runs once on component mount

    return (
        <div id="account-settings">
            <div className='row'>
                <img src='assets/imgs/backup.png' alt="User profile"></img>
                <h1>Current Collector: {user}</h1>
            </div>
            <div>
            <div>
                Current Address: {currentAddress || "Loading..."} 
            </div>
            <div id="login">
                    <label className='label'>
                    Address
                    <input
                        className="input-box"
                        type="text"
                        name="address"
                        placeholder=""
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        required
                    />
                    </label>
                    <label className='label'>
                    City
                    <input
                        className="input-box"
                        type="text"
                        name="city"
                        placeholder=""
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        required
                    />
                    </label>
                    <label className='label'>
                    Postcode
                    <input
                        className="input-box"
                        type="text"
                        name="postcode"
                        placeholder=""
                        value={postcode}
                        onChange={(e) => setPostcode(e.target.value)}
                        required
                    />
                    </label>
                    <label className='label'>
                    State
                    <input
                        className="input-box"
                        type="text"
                        name="state"
                        placeholder=""
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        required
                    />
                    </label>
            </div>
            <button className='button' onClick={() => {updateAddress(address, city, postcode, state)}}>
                <h2>Update Address</h2>
            </button>
        </div>

        </div>
    );
};

export default ProfileComponent